// What the page says about an import request that did not answer 200.

const UNFINISHED =
  "The upload did not finish. Reload the list to see whether it was applied; uploading the same files again is safe.";
const NO_ACCESS = "You do not have access to upload warm-up sets.";

const STATUS_REFUSED = 400;
const STATUS_FORBIDDEN = 403;
const STATUS_INVALID_BODY = 422;

// FastAPI answers a body that fails its schema with a list of {loc, msg}.
const detailText = (detail) =>
  Array.isArray(detail)
    ? detail.map(({ loc = [], msg }) => [loc[loc.length - 1], msg].filter(Boolean).join(": ")).join("; ")
    : detail;

/** True when the rejection is the import report of a refused upload. */
export const isRefusedReport = (error) => error?.status === STATUS_REFUSED && Array.isArray(error.errors);

/** The danger-alert text for a failed import request. */
export const failureMessage = (error) => {
  if (error?.status === STATUS_FORBIDDEN) return NO_ACCESS;
  if (error?.status === STATUS_INVALID_BODY) return `The server refused the files: ${detailText(error.detail)}`;
  if (error?.status && error.detail) return detailText(error.detail);
  return UNFINISHED;
};
